<!--
/*******************************************************************************
*@ 컴포넌트명   : AccountDetailPopup.vue
*@ 컴포넌트설명 : 계좌 상세조회
*@ 사용전문     : RBF0404B40 - 예금계좌상세조회
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <popup :opened.sync="openData" :use-footer="true" title="MINQ-01-01-08-01">
    <template #content>
      <article class="contents">
        <div class="account-info -type4">
          <div class="tit">{{ RBF0404B40.acnoAls }}</div>
          <div class="desc">
            <div class="item account">{{ `${RBF0404B40.acno} - ${RBF0404B40.prdctName}` }}</div>
          </div>
          <div class="sub" v-if="RBF0404B40.acnoKnd2 == '4'">
            <progress-bar :percent="percent">
              <template #term>
                <template v-if="RBF0404B40.acnDtailCd === '4'">{{ $t("MLON-01-01-04-03", { 1: $n(RBF0404B40.totalPaymtzNth) }) }}</template>
                <template v-else>{{ /*재예치기간2*/ RBF0404B40.ctrcTrmCnt }}{{ RBF0404B40.ctrcUnitDstcd }}</template>
              </template>
              <template #start>
                {{ /*시작일*/ $t("MINQ-01-01-08-04") }}
                <br />
                {{ $getGlobalDateFmt(RBF0404B40.newYmd) }}
              </template>
              <template #end>
                {{ /*만기일*/ $t("MINQ-01-01-08-05") }}
                <br />
                {{ $getGlobalDateFmt(RBF0404B40.expirYmd) }}
              </template>
              <template #ing>
                {{ days }}
                <br />
                <em>{{ /*days*/ $t("MINQ-01-01-08-27") }}</em>
              </template>
            </progress-bar>
          </div>
        </div>
        <dl class="dlist dlist-item--type4">
          <!-- 보통예금 -->
          <template v-if="RBF0404B40.acnDtailCd == '1'">
            <dt>{{ /*계좌번호*/ $t("MINQ-01-01-06-04") }}</dt>
            <dd>{{ RBF0404B40.acno }}</dd>
            <dt>{{ /*계좌명*/ $t("MINQ-01-01-06-05") }}</dt>
            <dd>{{ RBF0404B40.prdctName }}</dd>
            <dt>{{ /*예금주명*/ $t("MINQ-01-01-06-07") }}</dt>
            <dd>{{ RBF0404B40.ovsesCustOcntryName }}</dd>
            <dt>{{ /*통화코드*/ $t("MINQ-01-01-06-08") }}</dt>
            <dd>{{ RBF0404B40.cncycd }}</dd>
            <dt>{{ /*출금가능금액*/ $t("MINQ-01-01-06-10") }}</dt>
            <dd class="right">
              <span class="amount" v-html="$num(RBF0404B40.drwotAbilAmt, null, true)"></span>
            </dd>
            <dt>{{ /*총잔액*/ $t("MINQ-01-01-06-09") }}</dt>
            <dd class="right">
              <span class="amount" v-html="$num(RBF0404B40.bal, null, true)"></span>
            </dd>
            <dt>{{ /*신규일*/ $t("MINQ-01-01-06-11") }}</dt>
            <dd>{{ $getGlobalDateFmt(RBF0404B40.newYmd) }}</dd>
            <dt>{{ /*계좌상태*/ $t("MINQ-01-01-06-12") }}</dt>
            <dd>{{ $t(`${RBF0404B40.acnStus}_계좌상태구분코드`) }}</dd>
            <dt v-if="RBF0404B40.limtRsrctAcnoYn == 1">{{ /* 비대면 한도제한계좌 */ $t("EKYC-21-11") }}</dt>
            <dd v-if="RBF0404B40.limtRsrctAcnoYn == 1">{{ /* 여 */ $t("EKYC-21-12") }}</dd>
          </template>
          <!-- 당좌예금 -->
          <template v-else-if="RBF0404B40.acnDtailCd == '2'">
            <dt>{{ /*계좌번호*/ $t("MINQ-01-01-06-04") }}</dt>
            <dd>{{ RBF0404B40.acno }}</dd>
            <dt>{{ /*계좌명*/ $t("MINQ-01-01-06-05") }}</dt>
            <dd>{{ RBF0404B40.prdctName }}</dd>
            <dt>{{ /*예금주명*/ $t("MINQ-01-01-06-07") }}</dt>
            <dd>{{ RBF0404B40.ovsesCustOcntryName }}</dd>
            <dt>{{ /*통화코드*/ $t("MINQ-01-01-06-08") }}</dt>
            <dd>{{ RBF0404B40.cncycd }}</dd>
            <dt>{{ /*출금가능금액*/ $t("MINQ-01-01-06-10") }}</dt>
            <dd class="right">
              <span class="amount" v-html="$num(RBF0404B40.drwotAbilAmt, null, true)"></span>
            </dd>
            <dt>{{ /*총잔액*/ $t("MINQ-01-01-06-09") }}</dt>
            <dd class="right">
              <span class="amount" v-html="$num(RBF0404B40.bal, null, true)"></span>
            </dd>
            <dt>{{ /*당좌약정금액*/ $t("MINQ-01-01-06-18") }}</dt>
            <dd class="right">
              <span class="amount" v-html="$num(RBF0404B40.cracAgreAmt, null, true)"></span>
            </dd>
            <dt>{{ /*신규일*/ $t("MINQ-01-01-06-11") }}</dt>
            <dd>{{ $getGlobalDateFmt(RBF0404B40.newYmd) }}</dd>
            <dt>{{ /*계좌상태*/ $t("MINQ-01-01-06-12") }}</dt>
            <dd>{{ $t(`${RBF0404B40.acnStus}_계좌상태구분코드`) }}</dd>
          </template>
          <!-- 정기예금 -->
          <template v-else-if="RBF0404B40.acnDtailCd == '3'">
            <dt>{{ /*계좌번호*/ $t("MINQ-01-01-06-04") }}</dt>
            <dd>{{ RBF0404B40.acno }}</dd>
            <dt>{{ /*계좌명*/ $t("MINQ-01-01-06-05") }}</dt>
            <dd>{{ RBF0404B40.prdctName }}</dd>
            <dt>{{ /*예금주명*/ $t("MINQ-01-01-06-07") }}</dt>
            <dd>{{ RBF0404B40.ovsesCustOcntryName }}</dd>
            <dt>{{ /*통화코드*/ $t("MINQ-01-01-06-08") }}</dt>
            <dd>{{ RBF0404B40.cncycd }}</dd>
            <dt>{{ /*총잔액*/ $t("MINQ-01-01-06-09") }}</dt>
            <dd class="right">
              <span class="amount" v-html="$num(RBF0404B40.bal, null, true)"></span>
            </dd>
            <dt v-html="/*계약기간*/ $t($ctrcUnitDstcd(RBF0404B40.ctrcUnitDstcd))"></dt>
            <dd class="right">{{ RBF0404B40.ctrcTrmCnt }} {{ $t($ctrcUnitDstcdType(RBF0404B40.ctrcUnitDstcd)) }}</dd>
            <dt>{{ /*신규일*/ $t("MINQ-01-01-06-11") }}</dt>
            <dd>{{ $getGlobalDateFmt(RBF0404B40.newYmd) }}</dd>
            <dt>{{ /*만기일*/ $t("MINQ-01-01-08-05") }}</dt>
            <dd>{{ $getGlobalDateFmt(RBF0404B40.expirYmd) }}</dd>
            <dt v-html="/*자동갱신여부*/ $t('MINQ-01-01-08-19')"></dt>
            <dd>{{ $t(`${RBF0404B40.expirExtenYn}_자동갱신여부`) }}</dd>
            <dt v-if="RBF0404B40.expirExtenYn == '1'">{{ /*갱신일*/ $t("MINQ-01-01-08-20") }}</dt>
            <dd v-if="RBF0404B40.expirExtenYn == '1'">{{ $getGlobalDateFmt(RBF0404B40.expirExtenYmd) }}</dd>
            <dt>{{ /*예금이율*/ $t("MINQ-01-01-08-21") }}</dt>
            <dd class="right">
              <span class="amount">{{ RBF0404B40.dpostIrt }}%</span>
            </dd>
            <dt>{{ /*계좌상태*/ $t("MINQ-01-01-06-12") }}</dt>
            <dd>{{ $t(`${RBF0404B40.acnStus}_계좌상태구분코드`) }}</dd>
          </template>
          <!-- 정기적금 -->
          <template v-else-if="RBF0404B40.acnDtailCd == '4'">
            <dt>{{ /*계좌번호*/ $t("MINQ-01-01-06-04") }}</dt>
            <dd>{{ RBF0404B40.acno }}</dd>
            <dt>{{ /*계좌명*/ $t("MINQ-01-01-06-05") }}</dt>
            <dd>{{ RBF0404B40.prdctName }}</dd>
            <dt>{{ /*예금주명*/ $t("MINQ-01-01-06-07") }}</dt>
            <dd>{{ RBF0404B40.ovsesCustOcntryName }}</dd>
            <dt>{{ /*통화코드*/ $t("MINQ-01-01-06-08") }}</dt>
            <dd>{{ RBF0404B40.cncycd }}</dd>
            <dt>{{ /*총잔액*/ $t("MINQ-01-01-06-09") }}</dt>
            <dd class="right">
              <span class="amount" v-html="$num(RBF0404B40.bal, null, true)"></span>
            </dd>
            <dt>{{ /*월납입금액*/ $t("MINQ-01-01-08-28") }}</dt>
            <dd class="right">
              <span class="amount" v-html="$num(RBF0404B40.mnPaymtzAmt, null, true)"></span>
            </dd>
            <dt v-html="/*계약기간*/ $t($ctrcUnitDstcd(RBF0404B40.indpCtrcUnitDstcd))"></dt>
            <dd class="right">{{ RBF0404B40.ctrcTrm }} {{ $t($ctrcUnitDstcdType(RBF0404B40.indpCtrcUnitDstcd)) }}</dd>
            <dt>{{ /*신규일*/ $t("MINQ-01-01-06-11") }}</dt>
            <dd>{{ $getGlobalDateFmt(RBF0404B40.newYmd) }}</dd>
            <dt>{{ /*만기일*/ $t("MINQ-01-01-08-05") }}</dt>
            <dd>{{ $getGlobalDateFmt(RBF0404B40.expirYmd) }}</dd>
            <dt>{{ /*납입회차*/ $t("MINQ-01-01-08-15") }}</dt>
            <dd class="right">{{ `${RBF0404B40.paymtzNth} / ${RBF0404B40.totalPaymtzNth}` }}</dd>
            <dt>{{ /*자동이체 계좌번호*/ $t("MINQ-01-01-08-16") }}</dt>
            <dd>{{ RBF0404B40.indplnkgAcno }}</dd>
            <dt>{{ /*자동이체일*/ $t("MINQ-01-01-08-17") }}</dt>
            <dd>{{ /*매월 {1}일에 자동이체*/ $t("MDEP-01-01-17-12", { 1: Number(RBF0404B40.newYmd.substring(6, RBF0404B40.newYmd.length)) }) }}</dd>
            <dt>{{ /*예금이율*/ $t("MINQ-01-01-08-21") }}</dt>
            <dd class="right">
              <span class="amount">{{ RBF0404B40.dpostIrt }}%</span>
            </dd>
            <dt>{{ /*계좌상태*/ $t("MINQ-01-01-06-12") }}</dt>
            <dd>{{ $t(`${RBF0404B40.acnStus}_계좌상태구분코드`) }}</dd>
          </template>
          <!-- 일반대출계좌 -->
          <template v-else-if="RBF0404B40.acnDtailCd == '5'">
            <dt>{{ /*계좌번호*/ $t("MINQ-01-01-06-04") }}</dt>
            <dd>{{ RBF0404B40.acno }}</dd>
            <dt>{{ /*계좌명*/ $t("MINQ-01-01-06-05") }}</dt>
            <dd>{{ RBF0404B40.prdctName }}</dd>
            <dt>{{ /*예금주명*/ $t("MINQ-01-01-06-07") }}</dt>
            <dd>{{ RBF0404B40.ovsesCustOcntryName }}</dd>
            <dt>{{ /*대출금액*/ $t("MINQ-01-01-10-07") }}</dt>
            <dd class="right">
              <span class="amount" v-html="RBF0404B40.cncycd + ' ' + $num(RBF0404B40.lnAmt, null, true)"></span>
            </dd>
            <dt>{{ /*대출잔액*/ $t("MINQ-01-01-10-08") }}</dt>
            <dd class="right">
              <span class="amount" v-html="RBF0404B40.cncycd + ' ' + $num(RBF0404B40.lnBal, null, true)"></span>
            </dd>
            <dt>{{ /*대출실행일*/ $t("MINQ-01-01-10-09") }}</dt>
            <dd>{{ $getGlobalDateFmt(RBF0404B40.lnExeYMS) }}</dd>
            <dt>{{ /*대출만기일*/ $t("MINQ-01-01-10-10") }}</dt>
            <dd>{{ $getGlobalDateFmt(RBF0404B40.lnExpirYmd) }}</dd>
            <dt v-html="/*상환방식*/ $t('MINQ-01-01-10-11')"></dt>
            <dd v-if="RBF0404B40.rpayWayDstcd != ''">{{ $t(`${RBF0404B40.rpayWayDstcd}_해외상환방법구분코드`) }}</dd>
            <dd v-else></dd>
            <dt v-html="/*거치기간*/ $t('MINQ-01-01-10-13')"></dt>
            <dd>{{ RBF0404B40.lnTrmCnt }} {{ $t($ctrcUnitDstcdType(RBF0404B40.brncoLnTrmCyclDstcd)) }}</dd>
            <dt>{{ /*대출이율*/ $t("MINQ-01-01-10-14") }}</dt>
            <dd class="right">
              <span class="amount">{{ RBF0404B40.lnIrt }}%</span>
            </dd>
            <dt>{{ /*대출금리종류*/ $t("MINQ-01-01-10-15") }}</dt>
            <dd>{{ $t(`${RBF0404B40.ovsesIrtDstcd}_해외금리구분`) }}</dd>
            <dt>{{ /*최종거래일*/ $t("MINQ-01-01-10-16") }}</dt>
            <dd>{{ $getGlobalDateFmt(RBF0404B40.lastTranYmd) }}</dd>
            <dt>{{ /*다음납입일*/ $t("MINQ-01-01-10-17") }}</dt>
            <dd>{{ $getGlobalDateFmt(RBF0404B40.nxtrmPaymtYmd) }}</dd>
            <!-- 당좌대출 차기이자납부금액 미표시 -->
            <dt v-if="RBF0404B40.ovsesLnFmatDstcd != '08'">{{ /*다음 이자 납입 금액*/ $t("MINQ-01-01-09-11") }}</dt>
            <dd v-if="RBF0404B40.ovsesLnFmatDstcd != '08'" class="right">
              <span class="amount" v-html="RBF0404B40.cncycd + ' ' + $num(RBF0404B40.nxtrmIntPaymtAmt, null, true)"></span>
            </dd>
            <dt>{{ /*연결계좌*/ $t("MINQ-01-01-10-19") }}</dt>
            <dd>{{ RBF0404B40.lnkgAcno }}</dd>
            <dt>{{ /*계좌상태*/ $t("MINQ-01-01-06-12") }}</dt>
            <template v-if="page !== 'rpayRsultInq'">
              <dd>{{ $t(`${RBF0404B40.acnStus}_계좌상태구분코드`) }}</dd>
            </template>
            <template v-if="page == 'rpayRsultInq'">
              <!-- 과거대출거래내역 조회 상세 시 종료로 일괄처리 -->
              <dd>{{ /*종료*/ $t("MINQ-01-01-06-20") }}</dd>
            </template>
          </template>
        </dl>
        <div class="info info-etc">{{ /*본 화면은 고객편의를 위하여 제공되는 것으로 법적효력이 없습니다.*/ $t("MINQ-01-01-08-24") }}</div>
      </article>
      <template>
        <popup :opened.sync="popupOpened" :use-header="true" :use-footer="true" title="MDEP-02-01-07-01" class="popup">
          <template #content>
            <termi-antici-inq :acno="RBF0404B40.acno" :cncycd="RBF0404B40.cncycd" :acnOtPutNm="RBF0404B40.acnoAls"></termi-antici-inq>
          </template>
          <template #footer>
            <div class="btn-area--full">
              <button class="btn md gray" v-if="isExpirTermiBtn" @click="goTermi()">{{ /*해지*/ $t("MDEP-02-01-01-09") }}</button>
              <button class="btn md normal" @click="popupClose()">{{ /*확인*/ $t("MCOM-0000003") }}</button>
            </div>
          </template>
        </popup>
      </template>
    </template>
    <template #footer>
      <div class="btn-area--full">
        <button class="btn icon gray" @click="openData = !openData">
          <i class="icon icon-back" />
        </button>
        <button class="btn md normal" @click="goTrascDtl()" v-if="page !== 'termiUpdat' && page !== 'rpayRsultInq'">{{ /*거래내역조회*/ $t("MINQ-01-01-10-23") }}</button>
        <button v-if="isExpirTermiBtn && siteCode != $config.SITECODE_OGMMR && page == 'termiUpdat'" class="btn md normal" @click="goTermi()">
          {{ /*해지*/ $t("MDEP-02-01-03-15") }}
        </button>
        <button v-if="isExpirUpdatBtn" class="btn md normal" @click="goReNew()">{{ /*갱신*/ $t("MDEP-02-01-03-16") }}</button>
        <!-- <button
          v-if="RBF0404B40.isAnticiInqBtn"
          class="btn md normal"
          @click="goAnticiInq()"
        >{{ /*해지예상조회*/ $t("MDEP-02-01-03-10") }}</button>-->
        <button v-if="RBF0404B40.isLnRpayamtBtn" class="btn md normal" @click="goLnRpayamt()">{{ /*대출금상환*/ $t("MMAIN-03-03-02-17") }}</button>
        <button v-if="RBF0404B40.isIntMnrcv" class="btn md normal" @click="goIntMnrcv(RBF0404B40)">{{ /*이자납부*/ $t("MLON-01-01-03-22") }}</button>
      </div>
      <modal-pop :opened.sync="openedError" class="modal" confirm="MCOM-0000003">
        <template #content>
          <span v-html="errMsg"></span>
        </template>
      </modal-pop>
    </template>
  </popup>
</template>

<script>
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import Common from "@/components/basic/Common";
import TermiAnticiInq from "@/components/page/deposit/TermiAnticiInq";
export default {
  name: "MyAccountsDtlPop",
  extends: Common,
  props: {
    page: {
      type: String,
      default: "",
    },
    isExpirTermiBtn: {
      //해지버튼
      type: Boolean,
      default: false,
    },
    isExpirUpdatBtn: {
      //갱신버튼
      type: Boolean,
      default: false,
    },
  },
  components: {
    TermiAnticiInq,
  },
  async mounted() {
    if (_.isEmpty(this.globalToday) || _.isNil(this.globalToday)) {
      this.globalToday = await this.ACT_GET_SERVERINFO_ALL().then(data => this.moment(data.sysDateTime, "YYYYMMDD").format("YYYYMMDD"));
    }
  },
  computed: {
    ...mapFields(["globalToday"]),
    ...mapFields("accounts", ["initAcno"]),
    ...mapFields("deposit/termiUpdat", ["RBF0404B40"]),
    ...mapFields(["lang", "siteCode", "pageLoading", "loading"]),
    ...mapFields("deposit/termiUpdat", ["depositTermi", "RBF0406H40"]),
    openData: {
      get() {
        return this.opened;
      },
      set(value) {
        if (!value) this.RBF0404B40 = [];
        this.opened = value;
      },
    },
    days: {
      get() {
        return this.globalToday ? this.moment(this.globalToday, "YYYYMMDD").diff(this.moment(this.RBF0404B40.newYmd, "YYYYMMDD"), "days") : "";
      },
    },
    term: {
      get() {
        return this.globalToday ? this.moment(this.RBF0404B40.expirYmd, "YYYYMMDD").diff(this.moment(this.RBF0404B40.newYmd, "YYYYMMDD"), "days") : "";
      },
    },
    percent: {
      get() {
        let prct = (this.days / this.term) * 100;

        if (prct > 100) {
          prct = 100;
        }
        return prct;
      },
    },
  },
  data() {
    return {
      // globalToday: "",
      opened: false,
      popupOpened: false,
      openedError: false,
      isrpayRsult: false, //과거대출내역조회 여부
    };
  },
  methods: {
    ...mapActions(["ACT_GET_SERVERINFO_ALL"]),
    ...mapActions("accounts/myAccounts", ["actSetRBF0404B40"]),
    RBF0404B40call(acno, acnDsticCd, brncoEcrypPwdValdnYn) {
      if (!this.isrpayRsult) {
        let param = {
          acno: acno,
          acnDsticCd: acnDsticCd,
          brncoEcrypPwdValdnYn: brncoEcrypPwdValdnYn,
        };

        this.$post("/account/inqury/AcnInqDtlPop", param, this.RBF0404B40Suc);
      }
    },
    RBF0404B40Suc(res) {
      this.RBF0404B40 = res.outItem;
      this.openData = true;
    },
    setRpayRsultData(data) {
      this.RBF0404B40 = data;
      this.RBF0404B40.acnDtailCd = "5"; // 대출계좌로 set
      this.isrpayRsult = true;
      this.openData = true;

      // this.$log.debug("RBF0404B40", RBF0404B40);
      this.$log.debug("this.RBF0404B40", this.RBF0404B40);
    },
    //거래내역조회
    goTrascDtl() {
      this.initAcno.acno = this.RBF0404B40.acno;

      if (this.RBF0404B40.acnoKnd2 == "3") {
        this.$router.push({ name: "transactionDetails" });
      } else {
        //1,2,3:예금 4:적금 5:대출
        if (this.RBF0404B40.acnDtailCd == "4") {
          //적금 거래내역조회
          this.$router.push({ name: "instypFxdepTrnhis" });
        } else if (this.RBF0404B40.acnDtailCd == "5") {
          //대출 거래내역조회
          this.$router.push({ name: "lnAcnTrnhis" });
        } else {
          //예금 거래내역조회
          this.$router.push({ name: "dfstlFxdepTrnhis" });
        }
      }
    },
    //해지예상조회
    goAnticiInq() {
      this.RBF0406D40Call();
      this.popupOpened = true;
    },
    RBF0406D40Call() {
      /* API_RBF0406D40 - 예금해지예상조회 호출 */
      this.$post(
        "/deposit/updat/TermiAnticiInq",
        {
          cncycd: this.RBF0404B40.cncycd, //해지통화코드
          dmndPageNo: "1", //요청페이지번호(입력부)
          pageLineCnt: this.$config.PAGING_LINE_CNT, //페이지라인수(입력부)
          trsaccKnd: 1, //해지예상조회여부
          acno: this.RBF0404B40.acno, //해지계좌번호
          termiYmd: this.moment().format("YYYYMMDD"), //해지일자
        },
        this.RBF0406D40Suc,
      );
    },
    async RBF0406D40Suc(res) {
      this.$set(this.depositTermi, "expectation", res.outItem);
    },
    //대출금상환
    goLnRpayamt() {
      this.$router.push({ name: "lnamtRpayAnticiInq", params: this.RBF0404B40 });
    },
    //이자납부
    goIntMnrcv() {
      this.$router.push({ name: "interestLoanPaymentView", params: this.RBF0404B40 });
    },
    //해지
    async goTermi() {
      if (this.RBF0404B40.acnStus == "1") {
        this.errMsg = this.$t(
          /*사고신고 상태에서는 해지를 하실 수 없습니다.<br/><br/>가까운 영업점을 방문하시어 사고신고 해제를 먼저하시고 계좌 해지를 진행해 주시기 바랍니다.*/ "MDEP-02-01-08-17",
        );
        this.openedError = true;
        return false;
      }

      let param = {
        termiYmd: this.moment().format("YYYYMMDD"),
        trsaccKnd: "1", //1:해지예상조회,0:예비거래
        acno: this.RBF0404B40.acno, //계좌번호
        cncycd: this.RBF0404B40.cncycd, //통화코드
      };
      this.$set(this.depositTermi, "acnoAls", this.RBF0404B40.acnoAls);
      /* API_RBF0406D40 - 예금해지예상조회 호출 */
      await this.$post("/deposit/updat/TermiAnticiInq", param, this.termiSucc);
    },
    termiSucc(res) {
      this.$set(this.depositTermi, "expectation", res.outItem);
      this.$router.push({ name: "termiStep1" });
    },
    //갱신
    goReNew() {
      if (this.siteCode == this.$config.SITECODE_OGAUC) {
        this.openedError = true;
        this.errMsg = this.$t("P084-002"); // 해당 거래가 불가한 상태로 영업점에 문의바랍니다.
      } else {
        /* API_RBF0406H40 - 예금갱신예비 호출 */
        this.$post(
          "/deposit/updat/DpostUpdatStep3",
          {
            trsaccKnd: "1", //갱신예상조회여부
            tranYmd: this.RBF0404B40.expirYmd, //갱신일자
            acno: this.RBF0404B40.acno, //계좌번호
            cncycd: this.RBF0404B40.cncycd, //갱신계좌통화코드
            prdctName: this.RBF0404B40.acnoAls, //갱신계좌명
          },
          this.RBF0406H40Suc,
        );
      }
    },
    RBF0406H40Suc(res) {
      this.RBF0406H40 = {
        ...res.outItem,
      };
      this.$router.push({ name: "renewalStep1" });
    },
    popupClose() {
      this.popupOpened = false;
    },
  },
};
</script>
